import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import domConstructTyped from 'dojo/dom-construct';
const domConstruct: any = domConstructTyped;
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import domStyle from 'dojo/dom-style';
// JS2TS: dropped dead dep "dojo/date/locale" (param dojoDateLocale) — imported in the original define() but never referenced in code or template.
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import "../../../HintBox"; // more/HintBox — non-dojo dep, unused as a value & not in this template; bare import force-keeps it in the emitted define().
import GenericDialog from '../../GenericDialog/GenericDialog';
import QAForm from '../EventQADialog/EventQADialog';
import template from './EventCommentsList.html?raw';
//"xstyle/css!./OccurrenceList.css"

class EventCommentsList extends compose(_WidgetBaseSP) {
    [key: string]: any;
    templateString: any = template;

    bookingID: any = null;
    occurrence: any = null;
    _comments: any = [];
    _requestedCommentId: any = null;
    _state = "new";

    dialog: any = null;
    qaForm: any = null;

    commentsTable: any = null;

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.RequestManager.silentExceptions = true;
    }

    startup(entitylist?: any): void {
        super.startup.apply(this, arguments as any);

        if (typeof (entitylist) != "undefined") {
            domClass.remove(this.sectionComments, "w3-hide");
            this._onLoadCommentsResponse(entitylist);
        }

        this.setNewButtonVisibility();
    }

    setNewButtonVisibility(bOverrideBoolValue?: any) {
        var actualValue = true;

        if (bOverrideBoolValue === true || bOverrideBoolValue === false) {
            actualValue = bOverrideBoolValue;
        } else {

        }

        if (actualValue === true) {
            domClass.remove(this.btnNewComment, "w3-hide");
        } else {
            domClass.add(this.btnNewComment, "w3-hide");
        }

        return actualValue;
    }

    loadComments() {

        domClass.add(this.sectionComments, "w3-hide");

        this._comments = [];

        var url = window.appRoot + "zal/GetCommentList";

        if (this.bookingID == null || typeof (this.bookingID) == "undefined") {
            return;
        }

        domClass.remove(this.sectionComments, "w3-hide");

        this.StandbyStart();
        this._state = "loading";

        this.RequestManager.post(
            url,
            {
                bookingID: this.bookingID
            },
            lang.hitch(this, "_onLoadCommentsResponse"),
            lang.hitch(this, "_onLoadCommentsError"),
            false // sync
        );
    }

    _onLoadCommentsResponse(commentList: any) {
        this.StandbyStop();
        this._state = "ready";
        this._comments = commentList;
        //console.log("_onLoadCommentsResponse", commentList);

        if (commentList.length > 0) {
            domClass.remove(this.CommentsContainer, "w3-hide");
        } else {
            if (this.setNewButtonVisibility() === true) {
                domClass.add(this.CommentsContainer, "w3-hide");
            } else {
                domClass.remove(this.CommentsContainer, "w3-hide");
                domConstruct.empty(this.CommentsContainer);
                domConstruct.create("div", {
                    style: {
                        "fontStyle": "italic"
                    },
                    className: "w3-text-gray",
                    "innerHTML": this.translations["General_noEntries"]//"keine Einträge"
                }, this.CommentsContainer)
            }

            return;
        }



        // employeeTasksContainer
        this.commentsTable = new Tabulator(this.CommentsContainer, {
            data: commentList,
            layout: "fitColumns",
            // JS2TS: options cast to any below (Tabulator @types reject editor:false / lang.hitch formatters)
            //height: "311px",
            columns: [
                {
                    title: this.translations["EventBookingCommentDialog__TableCol_Question"]/*"Frage"*/, field: "question", /*width: 100,*/ editor: false
                },
                {
                    title: this.translations["EventBookingCommentDialog__TableCol_QuestionAuthor"]/*"von"*/, field: "ref_asker.dispname", /*width: 100,*/ editor: false
                },
                {
                    title: this.translations["EventBookingCommentDialog__TableCol_Answer"]/*"Antwort"*/, field: "answer", /*width: 150,*/ editor: false, formatter: lang.hitch(this, "tableFormatterStatus")
                },
                {
                    title: this.translations["EventBookingCommentDialog__TableCol_AnswerAuthor"]/*"von"*/, field: "ref_responder.dispname", /*width: 150,*/ editor: false, formatter: lang.hitch(this, "tableFormatterStatus")
                },
                {
                    title: this.translations["EventBookingCommentDialog__TableCol_Actions"]/*"Aktionen"*/, field: "ID", width: 50, formatter: lang.hitch(this, "tableBtnActions"), headerSort: false
                },

            ],
            //rowFormatter: lang.hitch(this, "_appendNestedTable"),
        } as any);

        if (this._requestedCommentId != null) {
            this.showComment(this.getCommentFromList(this._requestedCommentId), this.bookingID);
        }
    }

    //custom formatter definition
    tableBtnActions(cell: any, formatterParams: any, onRendered: any) { //plain text value

        var data = cell.getRow().getData();

        var container = domConstruct.create("div");

        if (data._isResponder == true || data._isAsker == true) {
            var button = domConstruct.create("div");
            domClass.add(button, "w3-padding-small w3-center mds-bg-gray mds-hover-dark  w3-cell");
            domAttr.set(button, "innerHTML", "<i class='fa fa-pencil'>&nbsp;</i>");
            domAttr.set(button, "title", this.translations["EventBookingCommentDialog__TableBtnEdit"]);
            domConstruct.place(button, container);
            on(button, "click", lang.hitch(this, "_onClick__EditComment", data));
        } else {
            var button = domConstruct.create("div");
            domClass.add(button, "w3-padding-small w3-center mds-bg-gray mds-hover-dark  w3-cell");
            domAttr.set(button, "innerHTML", "<i class='fa fa-external-link-square'>&nbsp;</i>");
            domAttr.set(button, "title", this.translations["EventBookingCommentDialog__TableBtnShow"]);//"anzeigen");
            domConstruct.place(button, container);
            on(button, "click", lang.hitch(this, "_onClick__EditComment", data));
        }

        return container;
    }

    getCommentFromList(ID: any) {
        //console.log("getCommentFromList", ID, this._comments);
        for (var i = 0; i < this._comments.length; i++) {
            var comment = this._comments[i];

            if (comment.ID == ID) {
                return comment;
                break;
            }
        }
    }

    requestComment(ID: any) {
        this._requestedCommentId = ID;
        //console.log("requestComment", this._state);
        if (this._state == "ready") {

            this.showComment(this.getCommentFromList(ID), this.bookingID);
        }
    }

    showComment(entity: any, bookingID: any) {

        if ((entity == null || typeof (entity) == "undefined") && this._requestedCommentId != null) {
            console.warn(this.translations["EventBookingCommentList__EntityNotFound"]);//"Gesucherter Kommentar existiert nicht");
            alert(this.translations["EventBookingCommentList__EntityNotFound"]); // hihi, "gesuchert"
            return;
        }

        this._requestedCommentId = null;

        var dialog: any = new GenericDialog();
        this.dialog = dialog;

        dialog.hideSubtitleNode();

        this.genericDialog = dialog;
        domStyle.set(dialog.textNode, "height", "unset");

        var qa = new QAForm();
        qa.bookingID = bookingID;
        qa.startup(entity);

        dialog.addNodeToContent(qa.domNode);

        // verhinden dass mit "Enter" der Dialog beendet wird
        on(qa.domNode, "keyup", function (evt) {
            evt.stopPropagation();
        });

        dialog.set("header", this.translations["EventBookingCommentDialog__Heading"]); //"Frage & Antwort");
        //dialog.set("content", "Hier Freitexteingabe");
        dialog.set("callback", lang.hitch(this, "qaDialogCallback", qa));

        if (entity != null && entity._isAsker != true && entity._isResponder != true) {
            //dialog.set("ok", false);
            //dialog.set("cancel", false);
            dialog.set("close", true);
        } else {
            dialog.set("ok", true);
            dialog.set("cancel", true);
        }

        dialog.show();
    }

    _onClick_NewComment(evt: any) {
        evt.stopPropagation();

        this.showComment(null, this.bookingID);
    }

    _onClick__EditComment(entity: any, bookingID: any) {
        this.showComment(entity, bookingID);
    }

    _onLoadCommentsError(error: any) {
        this.StandbyStop();

        console.error(error.Message);
    }

    qaDialogCallback(qa: any, result: any) {
        qa.serializeData();
        var data = qa.get("data");

        //console.log("qaDialogCallback", data, result);

        this.dialog = null;
        this.qaForm = null;

        if (result != 1) {
            return;
        }

        this.saveComment(data);
    }

    saveComment(data: any) {

        this.StandbyStart();

        var url = window.appRoot + "zal/SaveComment";

        this.RequestManager.post(
            url,
            {
                jsonData: JSON.stringify(data)
            },
            lang.hitch(this, "_onSaveCommentResponse"),
            lang.hitch(this, "_onSaveCommentError"),
            false // sync
        );
    }

    _onSaveCommentResponse(response: any) {
        this.StandbyStop();
        this.loadComments();

        this.emit("CommentSaved");
    }

    _onSaveCommentError(error: any) {
        this.StandbyStop();

        alert(this.translations["EventBookingCommentDialog__ErrorSave"] + error.Message);
    }

    tableFormatterStatus(cell: any, formatterParams: any, onRendered: any) {

        var data = cell.getData();
        var value = cell.getValue();

        // pit-Farbe wird in BGR zurückgegeben. ganz toll.
        // aabbcc:ddeeff der hintere Teil interessiert uns

        return value;
    }
}
EventCommentsList.prototype.declaredClass = 'more.Legacy.Zal.EventCommentsList.EventCommentsList';

export default mdsWidget(EventCommentsList);
